var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32752)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32752)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.154 -5.55428L295.295 15.3115",
    stroke: "#47B0A2",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.602 41.6029L273.232 71.4111",
    stroke: "#47B0A2",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.131 12.3298L272.246 43.3073L279.979 91.6179C280.772 96.5747 275.459 100.233 271.111 97.7231L199.873 56.5937C195.525 54.0837 196.037 47.6528 200.726 45.8616L246.432 28.4032L264.317 -2.57438",
    stroke: "#47B0A2",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.421,
    cy: -3.55801,
    rx: 2.98082,
    ry: 2.98082,
    transform: "rotate(30 292.421 -3.55801)",
    fill: "#47B0A2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.7 -21.4209C95.7 39.7095 44.8024 89.2791 -18 89.2791C-80.8024 89.2791 -131.7 39.7095 -131.7 -21.4209C-131.7 -82.5513 -80.8024 -132.121 -18 -132.121C44.8024 -132.121 95.7 -82.5513 95.7 -21.4209Z",
    stroke: "url(#paint1_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7 -21.4205C83.7 33.2569 38.1749 77.5952 -18 77.5952C-74.175 77.5952 -119.7 33.2569 -119.7 -21.4205C-119.7 -76.098 -74.175 -120.436 -18 -120.436C38.1749 -120.436 83.7 -76.098 83.7 -21.4205Z",
    stroke: "url(#paint2_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7 -21.4211C73.7 27.8789 32.6521 67.8579 -18 67.8579C-68.6521 67.8579 -109.7 27.8789 -109.7 -21.4211C-109.7 -70.721 -68.6521 -110.7 -18 -110.7C32.6521 -110.7 73.7 -70.721 73.7 -21.4211Z",
    stroke: "url(#paint3_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7 -21.4206C63.7 22.5018 27.1293 58.1215 -18 58.1215C-63.1293 58.1215 -99.7 22.5018 -99.7 -21.4206C-99.7 -65.343 -63.1293 -100.963 -18 -100.963C27.1293 -100.963 63.7 -65.343 63.7 -21.4206Z",
    stroke: "url(#paint4_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7 -21.4212C52.7 16.586 21.0541 47.4104 -18 47.4104C-57.0541 47.4104 -88.7 16.586 -88.7 -21.4212C-88.7 -59.4283 -57.0541 -90.2527 -18 -90.2527C21.0541 -90.2527 52.7 -59.4283 52.7 -21.4212Z",
    stroke: "url(#paint5_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7 -21.4207C42.7 11.2089 15.5313 37.674 -18 37.674C-51.5313 37.674 -78.7 11.2089 -78.7 -21.4207C-78.7 -54.0503 -51.5313 -80.5154 -18 -80.5154C15.5313 -80.5154 42.7 -54.0503 42.7 -21.4207Z",
    stroke: "url(#paint6_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7 -21.4212C32.7 5.83091 10.0084 27.9367 -18 27.9367C-46.0084 27.9367 -68.7 5.83091 -68.7 -21.4212C-68.7 -48.6733 -46.0084 -70.7791 -18 -70.7791C10.0084 -70.7791 32.7 -48.6733 32.7 -21.4212Z",
    stroke: "url(#paint7_linear_19577_32752)",
    strokeOpacity: 0.4,
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32752",
    x1: -9.19292e-7,
    y1: 31.7143,
    x2: 296.203,
    y2: 138.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8EAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19577_32752",
    x1: -18,
    y1: -132.421,
    x2: -18,
    y2: 89.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19577_32752",
    x1: -18,
    y1: -120.736,
    x2: -18,
    y2: 77.8952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19577_32752",
    x1: -18,
    y1: -111,
    x2: -18,
    y2: 68.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19577_32752",
    x1: -18,
    y1: -101.263,
    x2: -18,
    y2: 58.4215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19577_32752",
    x1: -18,
    y1: -90.5527,
    x2: -18,
    y2: 47.7104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19577_32752",
    x1: -18,
    y1: -80.8154,
    x2: -18,
    y2: 37.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19577_32752",
    x1: -18,
    y1: -71.0791,
    x2: -18,
    y2: 28.2367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACBDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabBackground);
export default __webpack_public_path__ + "static/media/LabBackground.1e70e35c9a0a0d5683339e9c72044adf.svg";
export { ForwardRef as ReactComponent };